export default __webpack_public_path__ + "static/exit-intent-popup-796781c8d8dc431f75234c2556034e07.png";